/**
 * Persistence layer with expiration based on localStorage.
 */

import StoreConfig from '@/config';

const storageMock = {
  length: 0,
  getItem() {},
  setItem() {},
  removeItem() {},
  clear() {},
};

class NamespacedLocalStorage {
  constructor(localStorage, key) {
    this.localStorage = localStorage;
    this.key = key;
  }

  _makeKey(key) {
    return `${this.key}__${key}`;
  }

  getItem(name) {
    try {
      return this.localStorage.getItem(this._makeKey(name));
    } catch (error) {
      return null;
    }
  }

  setItem(name, value) {
    try {
      this.localStorage.setItem(this._makeKey(name), value);
    } catch (error) {
      console.error(error);
    }
  }

  removeItem(name) {
    try {
      this.localStorage.removeItem(this._makeKey(name));
    } catch (error) {
      console.error(error);
    }
  }
}

/**
 * 因为会有子域名，所以这里的key应该带上对应的语言参数，否则会冲突
 */
export default class BrowserPersistence {
  static KEY = `${StoreConfig.store_code.toUpperCase()}_M2_VENIA_BROWSER_PERSISTENCE`;

  constructor(localStorage = globalThis.localStorage || storageMock, store = StoreConfig.store_code) {
    this.storage = new NamespacedLocalStorage(localStorage, `${store.toUpperCase()}_M2_VENIA_BROWSER_PERSISTENCE`);
  }

  getRawItem(name) {
    return this.storage.getItem(name);
  }

  getItem(name) {
    try {
      const now = Date.now();
      const item = this.storage.getItem(name);

      if (!item) {
        return undefined;
      }

      const { value, ttl, timeStored } = JSON.parse(item);

      if (ttl && now - timeStored > ttl * 1000) {
        this.storage.removeItem(name);

        return undefined;
      }

      return JSON.parse(value);
    } catch (error) {
      return undefined;
    }
  }

  setItem(name, value, ttl) {
    try {
      const timeStored = Date.now();

      this.storage.setItem(
        name,
        JSON.stringify({
          value: JSON.stringify(value),
          timeStored,
          ttl,
        }),
      );
    } catch (error) {
      console.error(error);
    }
  }

  removeItem(name) {
    this.storage.removeItem(name);
  }
}
